import {AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SharedService} from '../../shared/shared.service';
import {AuthService} from '../auth.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {LocalStorageService} from 'angular-2-local-storage';
import {Location} from '@angular/common';
import {LoggerService} from 'app/logger/logger.service';

const OTP_REGEX = /^\d+$/;

@Component({
  selector: 'app-email-otp-verify',
  templateUrl: './email-otp-verify.component.html',
  styleUrls: ['./email-otp-verify.component.css']
})
export class EmailOtpVerifyComponent implements OnInit, AfterContentChecked {
  // variable define
  verify_valid: boolean;
  otp_first: string;
  otp_second: string;
  otp_third: string;
  otp_fourth: string;
  otp_fifth: string;
  otp_resent = false;
  username: string;
  email: string;
  @Input('simple') simple = false;
  @Input('isMobileExpressPay') isMobileExpressPay = false;
  @Input('expressPayAccountNumber') expressPayAccountNumber = undefined;
  @Input('overrideCallbacks') overrideCallbacks = false;
  @Input('displayHeaderMessages') displayHeaderMessages = false;
  @Output() onResend: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChangeEmail: EventEmitter<any> = new EventEmitter<any>();
  @Output() onVerify: EventEmitter<any> = new EventEmitter<any>();
  @Output() onValidate: EventEmitter<any> = new EventEmitter<any>();
  public disable_div: string;
  public btn_value: string;
  private token: string;
  private raw_id: string;
  private is_acc_setting: boolean;

  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
              private authService: AuthService, private router: Router, private logger: LoggerService, private location: Location,
              private localStorageService: LocalStorageService, private cdr: ChangeDetectorRef) {
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  onResendCallback(successful: boolean): void {
    this.onResend.emit(successful)
  }

  onChangeEmailCallback(): void {
    this.onChangeEmail.emit()
  }

  onVerifyCallback(): void {
    this.onVerify.emit()
  }

  onValidateCallBack(success: boolean): void {
    this.onValidate.emit({success})
  }

  verifyValidate(verify_val: any) {
    if (!verify_val.target.value.match(OTP_REGEX)) {
      verify_val.target.value = '';
    }
    if (verify_val.target.id === 'otp_first') {
      this.otp_first = verify_val.target.value;
      if (this.otp_first !== '') {
        document.getElementById('otp_second').focus();
        this.otp_first = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_first').focus();
      }
    }
    if (verify_val.target.id === 'otp_second') {
      this.otp_second = verify_val.target.value;
      if (this.otp_second !== '') {
        document.getElementById('otp_third').focus();
        this.otp_second = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_first').focus();
      }
    }
    if (verify_val.target.id === 'otp_third') {
      this.otp_third = verify_val.target.value;
      if (this.otp_third !== '') {
        document.getElementById('otp_fourth').focus();
        this.otp_third = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_second').focus();
      }
    }
    if (verify_val.target.id === 'otp_fourth') {
      this.otp_fourth = verify_val.target.value;
      if (this.otp_fourth !== '') {
        document.getElementById('otp_fifth').focus();
        this.otp_fourth = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_third').focus();
      }
    }
    if (verify_val.target.id === 'otp_fifth') {
      this.otp_fifth = verify_val.target.value;
      if (this.otp_fifth !== '') {
        this.otp_fifth = ('' + verify_val.target.value)[0];
        verify_val.target.value = ('' + verify_val.target.value)[0];
      } else {
        document.getElementById('otp_fourth').focus();
      }
    }

    if (this.otp_first !== '' && this.otp_second !== '' && this.otp_third !== '' && this.otp_fourth !== '' && this.otp_fifth !== '') {
      this.verify_valid = true;
      if (verify_val.keyCode === 13) {
        document.getElementById('verify_btn').click();
      }
    } else {
      this.verify_valid = false;
    }
  }

  // make a REST call for otp verification
  verifyOTP() {
    this.disable_div = 'disable-div';
    this.verify_valid = false;
    this.btn_value = 'Verifying...';
    if (this.displayHeaderMessages) {
      this.sharedService.setHeaderErrorMessage('email_otp_verify', false, 'notification error', '');
      this.sharedService.setHeaderSuccessMessage('email_otp_verify', false, 'Your OTP has been successfully sent.');
    }
    const req_obj = {
      token: this.token,
      emailOtpKey: this.otp_first + this.otp_second + this.otp_third + this.otp_fourth + this.otp_fifth,
      rawId: this.raw_id,
      ban: this.isNumeric(this.expressPayAccountNumber) && this.expressPayAccountNumber !== 0 ? this.expressPayAccountNumber : '',
      email: !this.isNumeric(this.expressPayAccountNumber) ? this.expressPayAccountNumber : ''
    };

    const methodName = this.constructor.name + '.verifyOTP';
    if (req_obj) {
      this.authService.verifyEmailOTP(req_obj)
        .then(res => {
          if (res.status === 'success') {
            const logObj = {
              method: methodName,
              request: req_obj,
              response: res
            };
            this.logger.logInfo(JSON.stringify(logObj));
            if (this.displayHeaderMessages) {
              this.sharedService.setHeaderErrorMessage('email_otp_verify', false, 'notification error', '');
            }
            this.btn_value = 'Verify';
            this.disable_div = '';
            this.verify_valid = true;
            this.localStorageService.set('token', this.token);
            if (this.overrideCallbacks) {
              this.onVerifyCallback();
            } else {
              // this.router.navigate(['./dashboard']);
            }
          } else {
            window.scrollTo(0, 0);
            if (this.displayHeaderMessages) {
              this.sharedService.setHeaderErrorMessage('email_otp_verify', true, 'notification error', res.message);
            }
            if (this.overrideCallbacks) {
              this.onValidateCallBack(res.success === 'success');
            }
            this.btn_value = 'Verify';
            this.disable_div = '';
            this.verify_valid = true;
          }
        }, (error) => {
          const logObj = {
            method: methodName,
            request: req_obj,
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex) => {
        const logObj = {
          method: methodName,
          request: req_obj,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
    }
  }

  // make REST call for resend otp
  OTPResend() {
    if (this.displayHeaderMessages) {
      this.sharedService.setHeaderErrorMessage('email_otp_verify', false, 'notification error', '');
      this.sharedService.setHeaderSuccessMessage('email_otp_verify', false, 'Your OTP has been successfully sent.');
    }
    const response = this.collectOTPCall(this.isMobileExpressPay
      ? this.authService.resendOTPExpress(this.expressPayAccountNumber)
      : this.authService.resendOTP(
        { 'token': this.token, 'email': this.username, 'sFor': 'email', 'accSetting': this.is_acc_setting}))
    if (this.overrideCallbacks) {
      this.onResendCallback(response);
    }
  }
  collectOTPCall(callback: Promise<any>) {
    let response = false;
    const methodName = this.constructor.name + '.OTPResend';
      callback.then(res => {
      const logObj = {
        method: methodName,
        request: 'token : [masked]',
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));
      window.scrollTo(0, 0);
      if (res.status === 'success') {
        response = true;
        this.otp_resent = true;
        setTimeout(() => {
          this.otp_resent = false;
        }, 10000)
        if (this.displayHeaderMessages) {
          this.sharedService.setHeaderSuccessMessage(
            'email_otp_verify',
            true,
            'Your new email verification link and OTP has been successfully sent.');
        }
      } else {
        if (this.displayHeaderMessages) {
          this.sharedService.setHeaderErrorMessage('email_otp_verify', true, 'notification error', res.message);
        }
      }
    }, (error) => {
      const logObj = {
        method: methodName,
        request: 'token : [masked]',
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex) => {
      const logObj = {
        method: methodName,
        request: 'token : [masked]',
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
      return response;
  }

  changeEmail() {
    if (this.overrideCallbacks) {
      this.onChangeEmailCallback();
    } else {
      // this.router.navigate(['Profile/AccountSetting/UpdateEmail'], { skipLocationChange: true });
      // this.location.back();
    }
  }

  isNumeric(str: string) {
    if (typeof str !== 'string') {
      return false
    }
    return !isNaN(Number(str)) && !isNaN(parseFloat(str))
  }

  ngOnInit() {
    // this.sharedService.setHeaderTitle('default_page');
    if (this.displayHeaderMessages) {
      this.sharedService.setHeaderTitleDynamicallyTrueFalse('email_otp_verify', false);
    }

    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['raw_id'] !== undefined && params['raw_id'].trim() !== '') {
        this.raw_id = params['raw_id'];
      }
      // if (params['token'] !== undefined && params['token'].trim() !== '') {
      //   this.token = params['token'];
      // }

      this.is_acc_setting = (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting');
    });

    this.token = this.localStorageService.get('token');

    this.disable_div = '';
    this.btn_value = 'Verify';
    if (this.token != null) {
      const methodName = this.constructor.name + '.verifyToken';
      this.sharedService.verifyToken({'token': this.token})
        .then(res => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          const person = res.results[0]['personal'];
          const service = res.results[0]['service'];
          if (res.status === 'success') {
            const dataLayerEvent = 'Email OTP Verify';
            (window as any).dataLayer.push({'event': dataLayerEvent, 'accountID': person[0].id.toString()});
            if (this.displayHeaderMessages) {
              this.sharedService.setHeaderUserLoggedIn('email_otp_verify', true, person[0]);
            }
            if (this.is_acc_setting) {
              this.email = person[0]['tempEmail'];
            } else {
              this.email = person[0]['email'];
              if (person[0]['tempEmailOtpVerify']) {
                this.localStorageService.set('token', this.token);
                // this.router.navigate(['./dashboard']);
              }
            }
            const that = this.sharedService;
            if (this.displayHeaderMessages) {
              setTimeout(function () {
                that.setHeaderErrorMessage('email_otp_verify', false, 'notification error', '');
                that.setHeaderSuccessMessage('email_otp_verify', false, 'Your OTP has been successfully sent.');
                that.setHeaderTitle('email_otp_verify');
              }, 10);
            }
          }
        }, (error) => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex) => {
        const logObj = {
          method: methodName,
          request: 'token : [masked]',
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
    } else if (this.localStorageService.get('email') != null) {
      this.email = this.localStorageService.get('email');
    }
    this.activatedRoute.params.subscribe((params: Params) => {
      this.username = params['username'];
    });
    this.verify_valid = false;
    this.otp_first = '';
    this.otp_second = '';
    this.otp_third = '';
    this.otp_fourth = '';
    this.otp_fifth = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/email-otp-verify/email-otp-verify.component.ts